module.exports = __webpack_public_path__ + "static/media/PaintBrush.ac0a2de2.svg";